import select from './select';
export default function max(iterable, selector) {
    const values = select(iterable, selector);
    return Math.max(...values);
}
